export const rowHeight = 140;
export const headerHeight = 48;
export const minRowHeight = 50;
export const maxRowHeight = 350;
